export default ({ headerText, enableEnhancedConversion }) => {
	return {
		headerText,
		enableEnhancedConversion,
	};
};
